export enum SearchMode {
  Chat = 'Chat',
  Global = 'Global',
}
